import { loc } from "../i18n/survey";

const followingusQuestion = {
  name: 'followingus',
  title: loc("quiz.followingus.title"),
  type: 'radiogroup',
  choices: [
    {
      value: 'Never',
      text: loc("quiz.followingus.choices.never"),
    },
    {
      value: 'Just discovered us',
      text: loc("quiz.followingus.choices.justDiscovered"),
    },
    {
      value: 'Less than 6 months',
      text: loc("quiz.followingus.choices.lessThan6Months"),
    },
    {
      value: '6 months to 1 year',
      text: loc("quiz.followingus.choices.sixTo12Months"),
    },
    {
      value: '1 to 2 years',
      text: loc("quiz.followingus.choices.oneToTwoYears"),
    },
    {
      value: '2+ years',
      text: loc("quiz.followingus.choices.twoPlusYears"),
    },
    
  ],
  isRequired: true,
};

export {
  followingusQuestion,
};